import React from 'react';
import { Layout } from 'antd';
import { ReactComponent as Ellada20Dark } from 'assets/icons/ellada_2_0_dark.svg';
import { ReactComponent as DigitalLogo } from 'assets/icons/ministry-digital-icon-new.svg';
import { ReactComponent as FinanceLogo } from 'assets/icons/ministry-finance-icon-new.svg';
// import { ReactComponent as KtpLogo2 } from 'assets/icons/logo_ktp.gov.svg';
// import { ReactComponent as Copyright2023Logo } from 'assets/icons/copyright _2023.svg';
// import { ReactComponent as EuropeanUnionLogo } from 'assets/icons/european_union.svg';
// import { ReactComponent as EspaLogo } from 'assets/icons/espa.svg';
// import { ReactComponent as GreeceGovernmentLogo } from 'assets/icons/government-greece-logo2.svg';
// import { ReactComponent as GreenMinistryLogo } from 'assets/icons/green_ministry_gov.svg';
import { ReactComponent as EnvironmentLogo } from 'assets/icons/ministry-environment-icon-new.svg';
// import { ReactComponent as AadeLogo } from 'assets/icons/logo_aade.gov.svg';
import { ReactComponent as KtpLogo } from 'assets/icons/KtP-compact-icon.svg';
import { useLocation } from 'react-router-dom';

const { Content } = Layout;

const Footer = () => {
  const location = useLocation();
  const isStaticPage = location.pathname === '/';
  return (
    !isStaticPage && (
      <Content id='app-footer' className="footer">
        {/* <div className="footer-line">
        </div> */}
        <div className="footer-content">
          <div className="footer-logo">
            <Ellada20Dark
              className="app-layout__logo-gr-2-0"
              onClick={() => window.open('https://greece20.gov.gr/', '_blank')}
            />
          </div>
          {/* <div id="environment-ministry-logo" className="footer-logo">
            <EnvironmentLogo className="digital_logo" />
          </div> */}
          <div className="footer-logo">
            <FinanceLogo 
              className="digital_logo" 
              onClick={() => window.open('https://minfin.gov.gr/', '_blank')}
            />
          </div>
          <div className="footer-logo">
            <DigitalLogo
              className="digital_logo"
              onClick={() => window.open('https://mindigital.gr/', '_blank')}
            />
          </div>
        </div>
      </Content>
    )
  );
};

export default Footer;
